<template>
  <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px">
    <form @submit.prevent="validateForm">
      <div class="row">
        <kt-col xs="12" sm="4" md="6">
          <kt-form-group>
            <kt-form-label for="from_date">
              {{ $t("label.from_date") }}
            </kt-form-label>
            <button
                id="reset_from_date"
                @click="clearFromDate"
                class="btn btn-label-danger trash-btn"
                type="button"
            >
              <i class="la la-trash-o"></i>
            </button>
            <datePicker
                format="YYYY-MM-DD HH:mm:ss"
                display-format="dddd jDD jMMMM jYYYY"
                input-class="form-control"
                id="from_date"
                name="from_date"
                v-model="query.from_date"
                type="datetime"
                required
            />
          </kt-form-group>
        </kt-col>

        <kt-col xs="12" sm="4" md="6">
          <kt-form-group>
            <kt-form-label for="to_date">
              {{ $t("label.to_date") }}
            </kt-form-label>
            <button
                id="reset_to_date"
                @click="clearToDate"
                class="btn btn-label-danger trash-btn"
                type="button"
            >
              <i class="la la-trash-o"></i>
            </button>
            <datePicker
                format="YYYY-MM-DD HH:mm:ss"
                display-format="dddd jDD jMMMM jYYYY"
                input-class="form-control"
                id="to_date"
                name="to_date"
                v-model="query.to_date"
                type="datetime"
                required
            />
          </kt-form-group>
        </kt-col>
        <div class="col-sm-6 my-2">
          <div class="form-group my-0">
            <label for="customer_fullname">نام و نام خانوادگی مشتری</label>
            <input class="form-control  px-3 rounded-pill" id="customer_fullname"
                   type="text"
                   v-model="query.customer_fullname">
          </div>
        </div>
        <div class="col-sm-6 my-2">
          <div class="form-group my-0">
            <label for="filter_status">{{$t('label.status')}}</label>
            <select class="form-control kt-selectpicker text-secondary" v-model="query.status"
                    id="filter_status">
              <option value="null"></option>
              <option value="0">در انتظار</option>
              <option value="1">لغو شده</option>
              <option value="2">موفق</option>
            </select>
          </div>
        </div>

        <div class="col-sm-12 my-2">
          <button id="export_excel" :class="query ? 'btn btn-success mr-2' : 'btn btn-success btn-block'" style="border-radius: 10px;">خروجی اکسل</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import { i18n } from '../../../plugins/i18n';
import toastr from 'toastr';

export default {
  name: 'sub-factor-filter',
  data() {
    return {
      query: {
        from_date: '',
        to_date: '',
        customer_fullname: '',
        status: '',
      },
    }
  },
  computed: {
    hasQueryNull() {
      return this.query.from_date === "" || this.query.to_date === "";
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false,
      };
      return toastr;
    },
  },
  methods: {
    clearFromDate() {
      this.query.from_date = "";
    },
    clearToDate() {
      this.query.to_date = "";
    },
    validateForm() {
      if (this.hasQueryNull) {
        this.toastr.error("فیلد تاریخ نمی تواند خالی بماند.")
      } else {
        this.$emit("exportExcel", this.query);
      }
    },
    reset_and_get(e) {
      this.query = {
        status: '',
        from_date: '',
        to_date: '',
        customer_fullname: '',
      };
      this.$forceUpdate()
      this.afterDispatch()
      // this.$emit('action', e, this.query)
    },
  }
};
</script>

<style scoped>

</style>